import CMSPortalModel from '@netx/core-cms/models/CMSPortal';

export const currentPortal = new CMSPortalModel();

export default currentPortal;
